/* istanbul ignore file */
// TODO: Create test file

import { computed, inject } from 'vue';
import useCopyData from './useCopyData';
import usePhotoData from './usePhotoData';
import { SPECIALTY_DATA } from '../../constants/SalesFloor';

const findByTopCategory = (data) => ({
  getByTopLevelCategory: (value) => data.find(({ topLevelCategoryID }) => topLevelCategoryID === value),
  getByCategory: (value) => data.find(({ categories = [] }) => categories.includes(value)),
});

const getSpecialtyDataByCategory = (entryPoint, { categoryID = '', topLevelCategoryID = '' }) => {
  const { getByTopLevelCategory, getByCategory } = findByTopCategory(SPECIALTY_DATA[entryPoint]);
  return getByTopLevelCategory(topLevelCategoryID) || getByCategory(categoryID) || {};
};

const getSpecialtyDataByRegistry = (entryPoint) => SPECIALTY_DATA[entryPoint].find(({ categoryName }) => categoryName === 'registry' || categoryName === 'celebration') || {};

export default function useSpecialtylData() {
  const entryPoint = inject('entryPoint');
  const isRegistry = inject('isRegistry');
  const specialtyData = inject('specialtyData');

  const formattedSpecialtyData = computed(() => (isRegistry?.value ? getSpecialtyDataByRegistry(entryPoint?.value)
    : getSpecialtyDataByCategory(entryPoint?.value, specialtyData?.value || {})));

  return {
    ...useCopyData({ type: 'specialty', copy: computed(() => formattedSpecialtyData?.value?.categoryName || '') }),
    ...usePhotoData({ type: 'specialty', photo: computed(() => formattedSpecialtyData?.value?.photoName || '') }),
    specialtyId: computed(() => formattedSpecialtyData?.value?.specialtyId),
  };
}
